// Client Delivery and Operations - job cards (step-by-step instructions), keyed by job code. (M cards)
// A step is { text, tag }; a red STOP bar is { stop }. Loaded automatically by constants/jobCards.js.

export const division = "Client Delivery and Operations";

export const cards = {
  M1: {
    title: "Starting a new month for an existing client",
    before: [
      "Last month's report",
      "Next month's scope from the founders",
    ],
    steps: [
      { text: "Take last month's report and delay log to the founders", tag: "Input given" },
      { text: "Receive next month's divisional scopes from the founders by the last working day", tag: "Scopes in" },
      { text: "Run card O2: hand them over, give the one-day window, commit the dates", tag: "Committed" },
      { text: "Carry over anything unfinished, with a new date and the reason", tag: "Carried over" },
    ],
    finishedWhen: "Next month's scopes are committed before it starts, and nothing unfinished has been quietly dropped.",
  },
  M2: {
    title: "The client changes scope mid-month",
    before: [
      "A change request from the client",
    ],
    steps: [
      { text: "Write down exactly what they are asking for", tag: "Request" },
      { text: "Is it a revision, or new work? If they are changing something already approved, it is new work", tag: "Classified" },
      { text: "Run card O8: which divisions, can they do it, by when", tag: "Checked" },
      { stop: "Founders decide, using that answer" },
      { text: "Tell the client what it changes, what it costs, and what it delays", tag: "Client told" },
      { text: "Only after they agree, update the scope and the dashboard", tag: "Updated" },
    ],
    finishedWhen: "The change is priced and dated before anyone starts on it.",
  },
  M3: {
    title: "The weekly client call",
    before: [
      "The weekly update sent before the call",
    ],
    steps: [
      { text: "Send the update before the call, not during it", tag: "Sent" },
      { text: "Make sure the right Division Leads are on the call", tag: "Attendees" },
      { text: "Write down every decision and every new request during the call", tag: "Notes" },
      { text: "Send the notes to the client and the Division Leads the same day", tag: "Shared" },
      { text: "Anything new is a scope change. Go to M2", tag: "Routed" },
    ],
    finishedWhen: "Decisions are written down and shared the same day.",
  },
  M4: {
    title: "Keeping the delivery dashboard",
    before: [
      "The committed scopes",
    ],
    steps: [
      { text: "One line per job: client, division, job, the project lead if there is one, who does it, due date, status", tag: "Structure" },
      { text: "Update it every day before you leave", tag: "Current" },
      { text: "Anything past its date is marked late the same day, not at the end of the week", tag: "Honest" },
      { text: "Founders and Division Leads can see it any time without asking you", tag: "Visible" },
    ],
    finishedWhen: "Anyone can open the dashboard and know where every client stands, without asking.",
  },
};
